import { render, staticRenderFns } from "./DetailType0.vue?vue&type=template&id=77d47082&"
import script from "./DetailType0.vue?vue&type=script&lang=js&"
export * from "./DetailType0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports